module.exports = __webpack_public_path__ + "static/media/png.49b87dce.png";